<template>
  <!-- 付款弹窗 -->
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false" @close="handleClose">
    <!-- 填写付款信息 -->
    <div>
      <!-- 返点费用表单 -->
      <el-form v-if="paymentType === 'rebate'" :model="rebateForm" :rules="rebateRules" ref="rebateForm" label-width="120px">
        <!-- 返点费用 -->
        <el-form-item label="返点费用" prop="rebateFee">
          <el-input v-model="rebateForm.rebateFee" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <!-- 税率（禁用） -->
        <el-form-item label="税率" prop="taxRate">
          <el-input v-model="rebateForm.taxRate" disabled>
            <template slot="append">%</template>
          </el-input>
        </el-form-item>

        <!-- 税额（禁用） -->
        <el-form-item label="税额" prop="taxAmount">
          <el-input v-model="rebateForm.taxAmount" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <!-- 应付费用（自动计算） -->
        <el-form-item label="应付费用" prop="rebatePayAmount">
          <el-input v-model="rebateForm.rebatePayAmount" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <!-- 收款人 -->
        <el-form-item label="收款人" prop="payee">
          <el-input v-model="rebateForm.payee" placeholder="请输入收款人"></el-input>
        </el-form-item>

        <!-- 付款时间 -->
        <el-form-item label="付款时间" prop="paymentTime">
          <el-date-picker v-model="rebateForm.paymentTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"  />
        </el-form-item>

        <!-- 付款操作人 -->
        <el-form-item label="付款操作人" prop="operator">
          <el-input v-model="rebateForm.operator" disabled></el-input>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="rebateForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <!-- 配合费用表单 -->
      <el-form v-if="paymentType === 'coordination'" :model="coordinationForm" :rules="coordinationRules" ref="coordinationForm" label-width="120px">
        <!-- 配合费用 -->
        <el-form-item label="配合费用" prop="coordinationFee">
          <el-input v-model="coordinationForm.coordinationFee" disabled>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>

        <!-- 收款人 -->
        <el-form-item label="收款人" prop="payee">
          <el-input v-model="coordinationForm.payee" placeholder="请输入收款人"></el-input>
        </el-form-item>

        <!-- 付款时间（禁用，仅展示） -->
        <el-form-item label="付款时间" prop="paymentTime">
          <el-date-picker v-model="coordinationForm.paymentTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;"  />
        </el-form-item>

        <!-- 付款操作人 -->
        <el-form-item label="付款操作人" prop="operator">
          <el-input v-model="coordinationForm.operator" disabled></el-input>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input v-model="coordinationForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 弹窗底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
// 导入保存付款API
import { savePayment } from '@/api/contract/contract'

export default {
  name: 'PaymentDialog',
  computed: {
    // 动态计算弹窗标题
    dialogTitle () {
      const typeText = this.paymentType === 'rebate' ? '返点费用' : '配合费用'
      const countText = this.selectedData.length > 1 ? `批量付款（${this.selectedData.length}条）` : '付款'
      return `${typeText} - ${countText}`
    }
  },
  data () {
    return {
      // 弹窗显示状态
      dialogVisible: false,
      // 保存按钮加载状态
      saveLoading: false,
      // 当前步骤：1-选择类型，2-填写信息
      step: 2, // 直接进入第二步，不需要选择类型
      // 付款类型：rebate-返点费用，coordination-配合费用
      paymentType: '',
      // 选中的数据（支持多条）
      selectedData: [],
      // 外部传入的付款类型（1-返点费用，2-配合费用）
      externalPayType: '',
      // 返点费用表单数据
      rebateForm: {
        rebateFee: '',       // 返点费用
        taxRate: '',         // 税率
        taxAmount: '',       // 税额
        rebatePayAmount: '',      // 应付费用
        payee: '',           // 收款人
        paymentTime: '',     // 付款时间
        operator: '',        // 付款操作人
        remark: ''           // 备注
      },
      // 配合费用表单数据
      coordinationForm: {
        coordinationFee: '', // 配合费用
        payee: '',           // 收款人
        paymentTime: '',     // 付款时间
        operator: '',        // 付款操作人
        remark: ''           // 备注
      },
      // 返点费用表单验证规则
      rebateRules: {
        payee: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        paymentTime: [
          { required: true, message: '请选择付款时间', trigger: 'change' }
        ]
      },
      // 配合费用表单验证规则
      coordinationRules: {
        payee: [
          { required: true, message: '请输入收款人', trigger: 'blur' }
        ],
        paymentTime: [
          { required: true, message: '请选择付款时间', trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    /**
     * 打开弹窗
     * @param {Array} selectedRows - 选中的数据数组
     * @param {String} payType - 付款类型：'1'-返点费用，'2'-配合费用
     */
    openDialog (selectedRows, payType) {
      this.selectedData = selectedRows
      this.externalPayType = payType
      this.dialogVisible = true
      this.step = 2 // 直接进入第二步

      // 根据外部传入的类型设置付款类型
      if (payType === '1') {
        this.paymentType = 'rebate'
      } else if (payType === '2') {
        this.paymentType = 'coordination'
      }

      // 初始化表单数据
      this.initFormData()
    },

    /**
     * 初始化表单数据
     */
    initFormData () {
      // 获取当前登录用户
      const operator = this.$store.state.loginUser.userName || ''

      // 设置默认付款时间为当天
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      const paymentTime = `${year}-${month}-${day}`

      if (this.paymentType === 'rebate') {
        // 返点费用表单初始化 - 支持多条数据
        // 计算总返点费用、总税额、总应付费用
        let totalRebateFee = 0
        let totalTaxAmount = 0
        let totalPayableFee = 0
        let taxRate = 0

        this.selectedData.forEach(item => {
          const rebateFee = parseFloat(item.rebateFee) || 0
          const taxAmount = parseFloat(item.brokerTaxAmount) || 0
          totalRebateFee += rebateFee
          totalTaxAmount += taxAmount
          totalPayableFee += (rebateFee - taxAmount)

          // 取第一条数据的税率
          if (taxRate === 0) {
            taxRate = parseFloat(item.brokerTaxRate) || 0
          }
        })

        this.rebateForm = {
          rebateFee: totalRebateFee.toFixed(2),
          taxRate: taxRate.toFixed(2),
          taxAmount: totalTaxAmount.toFixed(2),
          rebatePayAmount: totalPayableFee.toFixed(2),
          payee: this.selectedData[0].rebateReceiptOperator || '', // 取第一条数据的返点收款人
          paymentTime: paymentTime,
          operator: operator,
          remark: ''
        }
      } else if (this.paymentType === 'coordination') {
        // 配合费用表单初始化 - 支持多条数据
        // 计算总配合费用
        let totalCoordinationFee = 0

        this.selectedData.forEach(item => {
          const coordinationFee = parseFloat(item.cooperationFee) || 0
          totalCoordinationFee += coordinationFee
        })

        this.coordinationForm = {
          coordinationFee: totalCoordinationFee.toFixed(2),
          payee: this.selectedData[0].cooperationReceiptOperator || '', // 取第一条数据的配合费收款人
          paymentTime: paymentTime,
          operator: operator,
          remark: ''
        }
      }
    },



    /**
     * 保存
     */
    handleSave () {
      const formRef = this.paymentType === 'rebate' ? 'rebateForm' : 'coordinationForm'

      // 表单验证
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          this.saveLoading = true

          // 构建保存数据 - 支持批量操作
          // saveData 为数组，每个元素对应一条勾选的数据
          let saveData = []

          if (this.paymentType === 'rebate') {
            // 返点费用参数 - 为每条数据构建对象
            saveData = this.selectedData.map(item => {
              const rebateFee = parseFloat(item.rebateFee) || 0
              const taxAmount = parseFloat(item.brokerTaxAmount) || 0
              const duePayAmount = rebateFee - taxAmount // 单条扣税后金额
              
              return {
                payType: 1,
                entrustNum: item.entrustNum, // 单条委托编号
                rebateReceiptOperator: this.rebateForm.payee, // 收款人
                rebateRemark: this.rebateForm.remark, // 返点付款备注
                paymentTime: this.rebateForm.paymentTime,
                operator: this.rebateForm.operator,
                rebatePayAmount: rebateFee, // 该条数据的返点费用（未扣税）
                rebateDuePayAmount: duePayAmount // 该条数据的实际应付（扣税后）
              }
            })
          } else {
            // 配合费参数 - 为每条数据构建对象
            saveData = this.selectedData.map(item => ({
              payType: 2,
              entrustNum: item.entrustNum, // 单条委托编号
              cooperationReceiptOperator: this.coordinationForm.payee, // 收款人
              cooperationRemark: this.coordinationForm.remark, // 配合费付款备注
              paymentTime: this.coordinationForm.paymentTime,
              operator: this.coordinationForm.operator,
              cooperationPayAmount: item.cooperationFee // 该条数据的配合费用
            }))
          }

          // 调用保存接口
          savePayment(saveData).then(res => {
            this.saveLoading = false
            if (res.retCode === 'ok') {
              this.$message.success('付款成功')
              this.handleClose()
              // 通知父组件刷新列表
              this.$emit('refresh')
            } else {
              this.$message.error(res.retMsg || '付款失败')
            }
          }).catch(error => {
            this.saveLoading = false
            console.error('保存失败:', error)
            this.$message.error('保存失败')
          })
        } else {
          this.$message.warning('请填写完整信息')
          return false
        }
      })
    },

    /**
     * 关闭弹窗
     * 清除数据并恢复默认状态
     */
    handleClose () {
      this.dialogVisible = false
      this.step = 2
      this.paymentType = ''
      this.selectedData = []
      this.externalPayType = ''

      // 重置表单
      if (this.$refs.rebateForm) {
        this.$refs.rebateForm.resetFields()
      }
      if (this.$refs.coordinationForm) {
        this.$refs.coordinationForm.resetFields()
      }

      // 清空表单数据
      this.rebateForm = {
        rebateFee: '',
        taxRate: '',
        taxAmount: '',
        rebatePayAmount: '',
        payee: '',
        paymentTime: '',
        operator: '',
        remark: ''
      }
      this.coordinationForm = {
        coordinationFee: '',
        payee: '',
        paymentTime: '',
        operator: '',
        remark: ''
      }
    }
  }
}
</script>

<style scoped>
/* 类型选择样式 */
.type-selection {
  padding: 20px;
}

.type-card {
  cursor: pointer;
  transition: all 0.3s;
}

.type-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.type-content {
  text-align: center;
  padding: 30px 0;
}

.type-content h4 {
  margin-top: 15px;
  font-size: 16px;
  color: #333;
}

/* 弹窗底部按钮样式 */
.dialog-footer {
  text-align: right;
}
</style>
